import React, { useEffect, useState } from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

export interface LazyLoaderProps<V> {
    elementFetcher: (offset: string, limit: string) => Promise<{results: V[], is_more_data: boolean}>
    limit?: number
}

export default function useLazyLoader<V, R extends HTMLElement>(props: LazyLoaderProps<V>) {

    // set default limit
    const limit = (props.limit ? props.limit : 10);

    const [elements, setElements] = useState<V[]>([]);

    const [offset, setOffset] = useState(0);

    const [end, setEnd] = useState(false);
    const [loading, setLoading] = useState(false);

    function getMoreData() {
        console.log("lazyLoading: GET MORE DATA");
        if(!end) {
            setLoading(true);
            // execute this code every time we get to bottom of div
            props.elementFetcher(offset.toString(), limit.toString()).then((resp) => {
                setElements((old) => {
                    return [...old, ...resp.results]
                })
                if(!resp.is_more_data) {
                    setEnd(true);
                } else {
                    setOffset((old) => {
                        return old + limit;
                    })
                }
                setLoading(false);
            })
        }
    }

    function deleteElement(index:number){
        setElements((oldProducts) => {
            oldProducts.splice(index, 1);
            return oldProducts;
        })
    }

    const lazyLoadingRef = useBottomScrollListener<R>(getMoreData)

    useEffect(() => {
        if ((lazyLoadingRef.current?.scrollHeight ?? 0) <= (lazyLoadingRef.current?.clientHeight ?? 0)) {
            getMoreData();
        }
    }, [elements])

    return {lazyLoadingRef, elements, end, loading, deleteElement}
}